var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIonicLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "148px",
    height: "148px",
    viewBox: "0 0 148 148",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ionic_Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ionic_Logo",
    transform: "translate(-0.000000, 0.000000)",
    fill: "#478AFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5154267,40.0402281 C55.0138875,40.0402281 40.0154267,55.038689 40.0154267,73.5402281 C40.0154267,92.0417672 55.0138875,107.040228 73.5154267,107.040228 C92.0169658,107.040228 107.015427,92.0417672 107.015427,73.5402281 C106.993386,55.0478264 92.0078284,40.0622691 73.5154267,40.0402281 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 121.615427,
    cy: 27.7502281,
    r: 15.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.405427,43.0902281 L139.765427,41.6902281 L138.765427,42.8502281 C136.263672,45.6889736 133.100198,47.8666534 129.555427,49.1902281 L128.555427,49.5502281 L128.955427,50.5502281 C140.075161,77.2917904 130.538244,108.160369 106.272386,123.969473 C82.0065272,139.778577 49.9165241,136.02976 29.9480486,115.053115 C9.97957311,94.0764701 7.81461108,61.8408553 24.7988035,38.3824484 C41.7829959,14.9240415 73.0835282,6.91788079 99.2454267,19.3402281 L100.185427,19.7902281 L100.595427,18.7902281 C102.089821,15.314344 104.418622,12.2607978 107.375427,9.90022809 L108.575427,8.90022809 L107.205427,8.19022809 C96.7975555,2.78083837 85.235065,-0.0291556094 73.5054267,0 C40.8871978,0.00491200134 12.1729503,21.5034838 2.98352628,52.8005022 C-6.20589775,84.0975206 6.32747365,117.70721 33.7653592,135.345557 C61.2032448,152.983905 96.9829151,150.432084 121.639866,129.078311 C146.296818,107.724538 153.933478,72.6763135 140.395427,43.0002281 L140.405427,43.0902281 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonicLogo);
export default __webpack_public_path__ + "static/media/Ionic_Logo.a4b3f42cbcf8daeb86d46699fa9c436c.svg";
export { ForwardRef as ReactComponent };